module.exports = __webpack_public_path__ + "static/img/6.864b83e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/6.png
// module id = RiFv
// module chunks = 2